(function () {
    'use strict';

    angular.module('app').controller('TransitWarrantyRatesController', TransitWarrantyRatesController);
    TransitWarrantyRatesController.$inject = [
        'TransitWarrantyRatesTableService'
    ];

    function TransitWarrantyRatesController(
        TransitWarrantyRatesTableService
    ) {
        const vm = this;

        init();

        function init() {
            vm.transitWarrantyRatesTableData = new TransitWarrantyRatesTableService().tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/TransitWarrantyRatesController.js